module.exports = __webpack_public_path__ + "img/tire-3.fd9623e7.png";